
import React, { Component } from 'react';
import moment from "moment";
import { MDBDataTable, MDBCol, MDBTableBody, MDBTableHead } from "mdbreact";

export default class ViewUpdateOrder extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ViewData: this.props.data.filter(val => val.fld_department_id != 6),
        }
    }


    render() {

        console.log(this.state.ViewData)

        const data = {
            columns: [
                {
                    label: "S.No.",
                    field: "sn",
                    // sort: "asc",
                    width: 150,
                },
                // {
                //     label: "Order Id",
                //     field: "orderid",
                //     sort: "asc",
                //     width: 270,
                // },
                // {
                //     label: "Order Number",
                //     field: "orderno",
                //     sort: "asc",
                //     width: 270,
                // },
               
                // {
                //     label: "Customer Name",
                //     field: "name",
                //     sort: "disabled",
                //     width: 100,
                // },
                // {
                //     label: "Customer Number",
                //     field: "number",
                //     sort: "disabled",
                //     width: 100,
                // },
                {
                    label: "Department",
                    field: "department",
                    sort: "disabled",
                    width: 150,
                },
                 {
                    label: "Update Date / Time",
                    field: "updatedate",
                    sort: "disabled",
                    width: 200,
                },
                {
                    label: "Updated By",
                    field: "updatedby",
                    sort: "disabled",
                    width: 200,
                },

                {
                    label: "Order Status",
                    field: "orderstatus",
                    sort: "disabled",
                    width: 100,
                },

                // {
                //     label: "Action",
                //     field: "action",
                //     sort: "disabled",
                //     width: 100,
                // },
            ],
            rows: this.state.ViewData.map((data, i) => {
                return {
                    sn: (i + 1),
                    // orderid: data.fld_order_id,
                    // orderno: (data.fld_order_number),
                    // name: (data.fld_customer_name),
                    // number: (data.fld_customer_number),
                    department: (data.fld_department_name),
                    updatedate:<span>
                    { data.fld_completion_date==null?null:moment(data.fld_completion_date.split("T")[0]).format("DD/MM/YYYY")}<br />
                    {data.fld_completion_date==null?null:data.fld_completion_date.split("T")[1].split(".")[0]}
                </span>,
                    updatedby : data.updated_by ,

                    orderstatus: data.updated_by == null ? "Pending" : "Completed",
                   
                }
            })
        }



        return (
            <>
                {this.state.ViewData.length != 0 ?
                    <MDBDataTable
                        hover
                        // scrollY
                        striped
                        bordered
                        data={data}
                        seachTop={false}
                        entriesOptions={[10, 20, 40, 60, 80, 100, 120, 140]}
                    >

                        <MDBTableHead columns={data.columns} />
                        <MDBTableBody rows={data.rows} />
                    </MDBDataTable>
                    :
                    <p>No Data Found</p>}
            </>

        )
    }
}
